// src/components/Sidebar.jsx
import React from "react";
import SidebarNavItem from "./SidebarNavItem";
import LogoutButton from "./LogoutButton";
// Import your SVG icon components or embed inline SVG
import {
  Drawer,
  List,
  Divider,
  Toolbar,
  Box,
  Typography,
  Avatar,
} from "@mui/material";

interface NavItem {
  label: string;
  icon: React.ReactNode;
  active?: boolean;
}

interface Props {
  navItems: NavItem[];
  onNavItemClick: (navItemIdx: number) => void;
  logout: () => void;
}
const Sidebar = ({ navItems, onNavItemClick, logout }: Props) => {
  const drawerWidth = 240;

  const selected = true;

  const getOnClick = (idx: number) => {
    return () => {
      onNavItemClick(idx);
    };
  };
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": { width: drawerWidth, boxSizing: "border-box" },
      }}
    >
      <Toolbar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "space-between",
        }}
      >
        <List>
          <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
            <Avatar src="https://cdn.usegalileo.ai/sdxl10/e2b4a201-5186-49bc-93fe-c4c965daf56a.png" />
            <Typography variant="h6" sx={{ ml: 2 }}>
              SAëF
            </Typography>
          </Box>
          <Divider />
          {navItems.map(({ label, icon, active }, idx) => (
            <SidebarNavItem
              key={label}
              label={label}
              icon={icon}
              active={active}
              onClick={getOnClick(idx)}
            />
          ))}
        </List>
        <Box sx={{ p: 2 }}>
          <LogoutButton logout={logout} />
        </Box>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
